import { Modal } from '@seiue/ui'
import { Input } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'

import { OutlineReq, courseApi } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'

/**
 * 编辑章节名称弹窗
 *
 * @param param0 - 参数
 * @param param0.outlines - 章节列表
 * @param param0.hide - 关闭弹窗
 * @param param0.outline - 章节
 * @param param0.activityTaskId - 活动任务 ID
 * @param param0.createIt - 创建任务
 * @returns 组件
 */
export const EditChapterNameModal: FC<{
  outlines: OutlineReq[]
  hide: () => void
  outline?: OutlineReq
  activityTaskId?: number
  createIt?: ({
    outlines,
  }: {
    outlines?: OutlineReq[] | undefined
  }) => Promise<void>
}> = ({ outlines, hide, outline, activityTaskId, createIt }) => {
  const [name, setName] = useState<string | undefined>(outline?.name)
  const { api: updateCourseOutline } = courseApi.useUpdateCourseOutline({
    reload: [courseApi.loadCourseActivityTask],
  })

  const { api: createCourseOutline } = courseApi.useCreateCourseOutline({
    reload: [courseApi.loadCourseActivityTask],
  })

  return (
    <>
      <Wrapper>
        <EditName>
          <Label>{'课程章节名称'}</Label>
          <EntryComponentsWrapper>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value)
              }}
              placeholder="请输入"
              autoFocus={true}
            />
          </EntryComponentsWrapper>
        </EditName>
      </Wrapper>
      <Modal.Footer
        okButtonProps={{ disabled: !name?.trim() }}
        okText={'确定'}
        onOk={async () => {
          if (outline?.id) {
            await updateCourseOutline({
              id: outline.id,
              payload: { ...outline, name },
            })
          } else {
            // 没有创建任务时先创建任务
            if (!activityTaskId) {
              await createIt?.({
                outlines: [
                  {
                    treeNodePid: 0,
                    name,
                    activityTaskId,
                    weight: 0,
                    treeNodeId: 1,
                  },
                ],
              })
            } else {
              await createCourseOutline({
                treeNodePid: 0,
                name,
                activityTaskId,
                weight: outlines.length,
              })
            }
          }
          hide()
        }}
        onCancel={() => {
          hide()
        }}
      />
    </>
  )
}

const Wrapper = styled.div`
  padding: 20px;
`

const EditName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${(p) => p.theme.text._2};
`
